/**
 * Where every key starts, which is exactly where the three control maps used to hardcode them.
 *
 * `fire` and `aim` default to no key at all, and that is not a gap: both are mouse buttons and
 * thumb controls, reported as named actions by the device, and a key is only ever an addition a
 * player chooses. An empty list here is what lets them go through the same rows as everything
 * else rather than being a second shape beside them.
 */

import type { BindingMap } from '@/core/input/bindings/bindingContract';

export const DEFAULT_BINDINGS: BindingMap = {
  moveForward: ['KeyW', 'ArrowUp'],
  moveBack: ['KeyS', 'ArrowDown'],
  moveLeft: ['KeyA', 'ArrowLeft'],
  moveRight: ['KeyD', 'ArrowRight'],
  sprint: ['ShiftLeft', 'ShiftRight'],
  crouch: ['ControlLeft', 'ControlRight', 'KeyC'],
  jump: ['Space'],
  fire: [],
  aim: [],
  reload: ['KeyR'],
  inspect: ['KeyT'],
  interact: ['KeyE'],
  firstAid: ['KeyG'],
  drill: ['KeyF'],
  cycleView: ['KeyV'],
  swapShoulder: ['KeyQ'],
  weaponSlot1: ['Digit1'],
  weaponSlot2: ['Digit2'],
  weaponSlot3: ['Digit3'],
  weaponSlot4: ['Digit4'],
  weaponSlot5: ['Digit5'],
  weaponSlot6: ['Digit6'],
};
